import { Row } from 'hatch-components';
import styled from 'styled-components';

export const StyledDrawerFooter = styled(Row)(
  ({ justifyContent, theme: { spacing } }) => ({
    flexShrink: 0,
    flexWrap: 'nowrap',
    justifyContent: justifyContent || 'flex-end',
    padding: spacing.md,
    width: '100%',
  }),
);
